import { render, staticRenderFns } from "./Page9.vue?vue&type=template&id=79e2041e&"
import script from "./Page9.vue?vue&type=script&lang=js&"
export * from "./Page9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports